/** Pure session-expiry decision, split out of the fetch client so it can be unit-
 *  tested without dragging the browser-only api.ts (localStorage, import.meta.env)
 *  into the Node typecheck/test program. Mirrors the other standalone lib helpers.
 *
 *  Sessions are 30-day JWTs. When one expires (or is otherwise invalidated) while
 *  the app is open, every guarded call starts returning 401. A 401 that means
 *  "your session is gone" should bounce the founder to /login — but a 401 from a
 *  *credential check* (wrong password on the login or change-password form) does
 *  NOT mean the session died; those callers show the error inline. */
const CREDENTIAL_CHECK_PATHS = ['/auth/login', '/auth/change-password'];

/** Pure: true when a 401 on `path` means the session is gone (vs. a bad-credential
 *  check on an auth form). Unit-tested in tests/session-expiry.test.ts. */
export function isSessionExpiry(status: number, path: string): boolean {
  if (status !== 401) return false;
  const p = path.split('?')[0];
  return !CREDENTIAL_CHECK_PATHS.includes(p);
}
